export const validateFormV2 = (formState) => {
    const errors = {};

    if (!formState.params.uploadFile) {
        errors.uploadFile = 'Please upload an Excel file';
    }
    if (!formState.params.identifierColumn) {
        errors.identifierColumn = 'Please select an Identifier column';
    }
    if (!formState.params.fundedColumn) {
        errors.fundedColumn = 'Please select a Funded column';
    }
    if (!formState.params.buyerId) {
        errors.buyerId = 'Buyer ID is required';
    }
    if (!formState.params.setSelectedButtons || formState.params.setSelectedButtons.length === 0) {
        errors.setSelectedButtons = 'At least one option must be selected';
    }
    if (!formState.params.current_startDate) {
        errors.current_startDate = 'Start Date is required';
    }
    if (!formState.params.current_endDate) {
        errors.current_endDate = 'End Date is required';
    }
    if (formState.params.current_startDate && formState.params.current_endDate) {
        if (formState.params.current_startDate > formState.params.current_endDate) {
            errors.current_endDate = 'End date must be after start date';
        }
    }

    return errors;
};

export const validateForm = (formState) => {
    const errors = {};

    // Required field validation
    if (!formState.params.buyerId) {
        errors.buyerId = 'Buyer ID is required';
    }
    if (!formState.params.setSelectedButtons || formState.params.setSelectedButtons.length === 0) {
        errors.setSelectedButtons = 'At least one option must be selected';
    }

    // Date validation
    if (!formState.params.current_startDate) {
        errors.current_startDate = 'Start Date is required';
    }
    if (!formState.params.current_endDate) {
        errors.current_endDate = 'End Date is required';
    }
    if (!formState.params.previous_startDate) {
        errors.previous_startDate = 'Start Date is required';
    }
    if (!formState.params.previous_endDate) {
        errors.previous_endDate = 'End Date is required';
    }

    // Date range validation
    if (formState.params.current_startDate && formState.params.current_endDate) {
        if (formState.params.current_startDate > formState.params.current_endDate) {
            errors.current_endDate = 'End date must be after start date';
        }
    }

    if (formState.params.previous_startDate && formState.params.previous_endDate) {
        if (formState.params.previous_startDate > formState.params.previous_endDate) {
            errors.previous_endDate = 'End date must be after start date';
        }
    }

    return errors;
};